import baseAssignmentsQuery from './baseAssignmentsQuery';

export default function toDoAssignmentsQuery(studentId: string, classroomId?: string) {
  return baseAssignmentsQuery(studentId, classroomId)
    .withMeta('assignment_v3')
    .customQuery({
      meta: {
        context: {
          student: {
            id: studentId,
            settings: true
          },
          classroom: {
            id: classroomId,
            settings: true
          },
          user: {
            id: studentId
          },
          isOpen: true
        }
      }
    });
  // .filter({
  //   'meta.is_open': true
  // });
}
